import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from '../occasion_details.module.scss';
import {TableRow} from '../../../components/table/table_row.tsx';
import {TableList} from '../../../components/table/table_list.tsx';
import {TableListCell} from '../../../components/table/table_list_cell.tsx';
import {capitalizeString} from '../../../support/string_format.ts';

interface OwnProps {
    occasion: OccasionType;
}

export function Options({occasion}: OwnProps) {
    const groupedOptionsByType: {[key: string]: string[]} = {};
    occasion.options?.map((occasionOption) => {
        if (occasionOption && occasionOption.category && occasionOption.option) {
            if (!groupedOptionsByType[occasionOption.category]) groupedOptionsByType[occasionOption.category] = [];
            groupedOptionsByType[occasionOption.category].push(occasionOption.option);
        }
    });

    return Object.keys(groupedOptionsByType)
        .sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
        })
        .map((key, index) => (
            <div key={`${index}-${key}`}>
                <div className={styles.tabs_title}>
                    <h2>{key}</h2>
                </div>
                <div className={styles.tabs_grid}>
                    <TableList>
                        {groupedOptionsByType[key]
                            .sort(function (a, b) {
                                return a.toLowerCase().localeCompare(b.toLowerCase());
                            })
                            .map(
                                (option: string, index) =>
                                    index % 2 === 0 && (
                                        <TableRow key={`${key}-${index}-${option}`} columns={1}>
                                            <TableListCell value={capitalizeString(option)} />
                                        </TableRow>
                                    ),
                            )}
                    </TableList>
                    <TableList>
                        {groupedOptionsByType[key]
                            .sort(function (a, b) {
                                return a.toLowerCase().localeCompare(b.toLowerCase());
                            })
                            .map(
                                (option: string, index) =>
                                    index % 2 !== 0 && (
                                        <TableRow key={`${key}-${index}-${option}`} columns={1}>
                                            <TableListCell value={capitalizeString(option)} />
                                        </TableRow>
                                    ),
                            )}
                    </TableList>
                </div>
            </div>
        ));
}
